import { ManualAssistantActions, ManualAssistantState } from 'redux/types/manualAssistantActionModel';
import * as actionTypes from '../actionTypes';

const initialState: ManualAssistantState = {
    isLoading: false,
    result: null,
};

export const manualAssistantReducer = (
    state = initialState,
    action: ManualAssistantActions,
): ManualAssistantState => {
    switch (action.type) {
        case actionTypes.MANUAL_ASSISTANT_QUERY_REQUEST:
            return {
                isLoading: true,
                result: null,
            };
        case actionTypes.MANUAL_ASSISTANT_QUERY_SUCCESS:
            return {
                isLoading: false,
                result: action.payload,
            };
        case actionTypes.MANUAL_ASSISTANT_QUERY_FAILURE:
            return {
                isLoading: false,
                result: {
                    kind: 'failed',
                    error: action.payload.error,
                    message: action.payload.message,
                },
            };
        default:
            return state;
    }
};
